import { CAPS_LOCK_WARNING } from "constants/settings";
import { GetTopicsListPayload } from "./topicsPayload"
import { config } from "utilities/config";
export const getTopicsListSchema = {
  title: "Add Topics",
  logicalname: "Contact2",
  type: "object",
  additionalDescription: CAPS_LOCK_WARNING,
  properties: {
    ctpt_topicsid: {
      title: "Topics",
      type: "string",
      datatype: "array",
      enum: [],
      enumNames: [],
      isDynamic: true,
      payload: GetTopicsListPayload,
      apiURL: config.teleportal.submitForm.get,
      isTopic: true
    }
  }
};

